const React = require("react");
const Layout = require("@eimerreis/lauterbad-components").Layout;

const socialMediaLinks = {
    Instagram: "https://www.instagram.com/hotellauterbad/",
    Facebook: "https://www.facebook.com/hotellauterbad/",
    Mail: "mailto:info@lauterbad-wellnesshotel.de",
    Phone: "tel:+497441860170"
}

const logo = "https://a.storyblok.com/f/63567/170x68/83c5cbaf60/logo-1.png";

exports.wrapPageElement = ({ element, props }) => {
    return (
        <Layout {...{...props.pageContext, socialMediaLinks, logo}}>
            {element}
        </Layout>
    )
}